export const STATUSORDER = Object.freeze({
  CanceladoEmpresa: 'Cancelado por rechazo de Empresa',
  Cotizado: 'Cotizado',
  PedidoDevuelto: 'Pedido revertido',
  
});
